import { Autocomplete, Box, Checkbox, Stack, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import {
  Color,
  FontStyle,
  defaultBottomPadding,
  defaultInnerStyle,
  defaultContainerStyle,
} from "../../constants";
import CheckButton from "../CheckButton";
import HeartButton from "../HeartButton";
import TempDisplay from "../TempDisplay";
import { CustomPaper, StyledTextField } from "../AutocompleteUtils";
import { useSelector } from "react-redux";

const styles = {
  container: {
    ...defaultContainerStyle,
  },
  inner: {
    ...defaultInnerStyle,
    "& .MuiFormControl-root": {
      border: "none",
    },
    px: { xs: "0.5rem", sm: 0 },
  },
  subtitle: {
    ...FontStyle.body,
    fontSize: "1rem",
    textAlign: "center",
  },
  link: {
    ...FontStyle.body,
    fontSize: "1rem",
    textAlign: "center",
    textDecoration: "underline",
    cursor: "pointer",
    color: "black",
  },
  body: {
    ...FontStyle.body,
    fontSize: "1rem",
    textAlign: "left",
    lineHeight: "1.4",
    maxWidth: "500px",
    "& > * >a": {
      color: "#000",
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    },
  },
  label: {
    ...FontStyle.headingBody,
    fontSize: "1rem",
    // textAlign: 'center',
    lineHeight: "1.4",
    width: "100%",
    maxWidth: "500px",
  },
  search: {
    width: "100%",
    backgroundColor: "rgb(255, 255, 255)",
    borderRadius: "4px",
    border: "1px solid rgb(204, 204, 204)",
  },
  searchProps: {
    disableUnderline: true,
  },
  info: {
    borderLeft: `6px solid ${Color.primary}`,
    borderRadius: "0.75rem",
    backgroundColor: "#fff",
    padding: "1.2rem",
  },
};

const Q15_Linkedin = ({
  selected,
  setSelected,
  setQuestionsDone,
  questionNum,
  options,
}) => {
  const serverRefreshes = useSelector((state) => state.survey.serverRefreshes);
  useEffect(() => {
    setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }));
  }, [selected]);
  const [linkedinUrl, setLinkedinUrl] = useState("");
  useEffect(() => {
    setSelected((s) => {
      return { ...s, [questionNum]: [linkedinUrl] };
    });
  }, [linkedinUrl]);
  // sync values from server
  useEffect(() => {
    if (serverRefreshes === 0) return;
    selected[questionNum].map((newUrl) => {
      setLinkedinUrl(newUrl);
    });
  }, [serverRefreshes]);
  return (
    <Stack
      direction="column"
      sx={styles.container}
      alignItems="center"
      spacing={2}>
      {/* <TempDisplay selected={selected} options={options} questionNum={questionNum} /> */}
      <Stack
        direction="column"
        sx={styles.inner}
        alignItems="left"
        justifyContent="center"
        spacing={1}>
        {/* <Box sx={styles.subtitle}>Paste the link to your LinkedIn profile below</Box> */}
        <Box sx={styles.label}>Linkedin URL</Box>
        <StyledTextField
          InputProps={styles.searchProps}
          sx={styles.search}
          variant="standard"
          value={linkedinUrl}
          onChange={(e) => setLinkedinUrl(e.target.value)}
          placeholder="https://linkedin.com/in/profile-name"
        />
      </Stack>
      <Stack
        direction="row"
        sx={{ width: "100%", paddingTop: "12px", paddingBottom: "12px" }}
        alignItems="center"
        justifyContent="center"
        spacing={1}>
        {/* <OpenInNewIcon sx={{ width: '18px' }} /> */}
        <a
          href="https://www.linkedin.com/in/"
          target="_blank"
          style={styles.link}>
          Don't know your Linkedin profile URL? Click here
        </a>
      </Stack>
      <Stack
        direction="column"
        sx={styles.inner}
        alignItems="center"
        justifyContent="center"
        spacing={1}>
        <Stack
          direction="row"
          sx={{ ...styles.body, textAlign: "left", width: "100%" }}>
          <Box sx={{ minWidth: "30px" }}>
            {/* <CheckIcon sx={{ width: '20px' }} /> */}
            💼
          </Box>
          {/* Be headhunted for exciting roles at our 1000+ companies */}
          Get your name in front of headhunters from 1000+ great companies right
          away
        </Stack>
        <Stack
          // alignItems="center"
          direction="row"
          sx={{ ...styles.body, textAlign: "left", width: "100%" }}>
          <Box sx={{ minWidth: "30px" }}>💪 </Box>
          {/* Only hiring managers on our platform can contact you. No third party recruiters */}
          Your LinkedIn is only visible to hiring managers who are a part of the
          Fetti platform (no third parties!)
        </Stack>
        <Stack
          // alignItems="center"
          direction="row"
          sx={{ ...styles.body, textAlign: "left", width: "100%" }}>
          <Box sx={{ minWidth: "30px" }}>🔓</Box>
          Your current employer won’t be able to see your profile
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Q15_Linkedin;
